import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2nlyab4cca: FaireBrandEntity = {
  token: "b_2nlyab4cca",
  type: "brand",
  name: "Sarah Wormann Art",
  avatarUrl: "https://cdn.faire.com/fastly/355a46db2f5c57ce885a86f2b7a091ea2db95f429c725149fccc2725453467b6.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/b7cd2bf3f1865a8f384bfbb312a110c67a86e43c9d4929cba11f491bb00cb08c.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/355a46db2f5c57ce885a86f2b7a091ea2db95f429c725149fccc2725453467b6.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/b7cd2bf3f1865a8f384bfbb312a110c67a86e43c9d4929cba11f491bb00cb08c.jpeg",
  location: "Boston, MA, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description: "Working from my home studio in Boston, I create art using watercolor, gouache, and ink. With a love of details and vibrant colors, I draw everything from house and building portraits to food illustrations and then turn them into prints, greeting cards, stickers, calendars, wedding stationery, and more!",
  meta: {
    source: "api",
    importedAt: "2026-10-09T07:53:32.738Z",
    importedBy: "entity-db-cli"
  }
};
